module.exports = __webpack_public_path__ + "media/images/lb/899-cbf81b61192b5a8810bb108cff7d8968.svg";